<template>
  <div class="videoClass">
    <div class="videoClasshtml">
      <div class="content">
        <p class="title">模型编写视频教程</p>
        <div class="jieshao" style="margin-top: 20px">
          <p class="module_tit">
            <span>介绍</span>
          </p>
          <p class="p_text" style="margin-top: 20px">
            本教程主要针对初级量化交易自学者编制，自学时对于不理解的知识点可通过视频反复回放学习；或到在线客服（按下图所示方法进入在线客服）中提问。通过视频、PPT、在线客服相结合的学习方式会让初学者很快掌握初级量化交易的应用。
          </p>
          <div class="pic">
            <img src="../../assets/images/lunttw.png" alt="" />
          </div>
          <p class="p_text" style="margin-top: 20px">
            本教程以视频为主，并配有PPT知识点学习指导和函数说明书。视频从认识量化交易、建立量化模型、运用软件实施量化交易等多个方面讲解，且每个方面都结合了大量的模型案例进行由浅入深的分析。每个章节按了解概念->讲述方法->指导编写->分析案例的过程分步展开。
          </p>
          <p class="p_text" style="margin-top: 20px">
            课程内容由模型的基本结构、跨指标、跨周期、跨合约、止损模型的编写到分组指令的编写，穿插模型实例使讲解更容易理解，另外还会对量化策略模型设计、回测等进行全面详细解析。函数说明书包含了所有麦语言现有的函数，并从函数意义、语法规则、用法举例三个方面对函数详解。
          </p>
          <p class="module_tit" style="margin-top: 30px">
            <span>费用</span>
          </p>
          <div class="maiyuy">
            <p class="p_text" style="margin-top: 15px">可通过会员积分进行兑换，或付费购买。具体所需的积分数量及费用，请参照课表所示内容。</p>
            <p class="p_text" style="margin-top: 5px">*购课后，一年内可无限次听课。</p>
          </div>
        </div>

        <div class="kechen" style="margin-top: 30px">
          <p class="module_tit">
            <span>课表</span>
          </p>
          <div class="kecheng_table">
            <table
              align="center "
              cellpadding="0 "
              cellspacing="0 "
              style="background: rgb(249,248,247) ;width:100%"
            >
              <thead>
                <tr>
                  <th style="width:45px">选课</th>
                  <th>课程内容</th>
                  <th style="width:85px">时长(分钟)</th>
                  <th style="width:85px">课程难度</th>
                  <th style="width:80px">积分兑换</th>
                  <th style="width:80px">价格</th>
                  <th style="width:68px" >教材</th>
                  <th style="width:68px" >线上课程 </th>
                </tr>
              </thead>
              <tbody v-for="(item,index) in tableList" :key="index">
                <tr v-for="(items,indexs) in item.Courses" :key="indexs">
                  <td v-if="indexs===0" :rowspan="item.Courses.length"><img @click="changestaus(index,item)" :src="item.active?require('../../assets/images/CV_01.png'):require('../../assets/images/CV_02.png')" alt="" :style="{cursor:!item.active&&$store.state.token&&!!item.ppt?'not-allowed':'pointer'}"></td>
                  <td style="text-align:left;padding-left:10px">{{items.productname}}</td>
                  <td>{{items.duration}}'</td>
                  <td>{{starcomp(items.difficulty)}}</td>
                  <td v-if="indexs===0" :rowspan="item.Courses.length">{{item.integral}}积分</td>
                  <td v-if="indexs===0" :rowspan="item.Courses.length">{{item.integral/10}}元</td>
                  <td v-if="indexs===0" :rowspan="item.Courses.length" :class="{hreactive:(!!$store.state.token&&!!item.ppt)||!$store.state.token}" @click="downloadPPt(item.ppt,index)" style="width:80px">下载ppt</td>
                  <td :class="{hreactive:(!!$store.state.token&&!!item.ppt)||!$store.state.token}" @click="listen(items.url,index,indexs)">去听课</td>
                </tr>
              </tbody>
            </table>
            <div class="table_bottom">
              <div style="margin-right:8px">
                合计：<span style="margin-right:3px">{{money}}</span>积分
              </div>
              <div class="yellow_btn" @click="gotoLogin">
                兑换
              </div>
              <div style="margin:0 8px 0 40px">
                <span style="margin-right:3px">{{money/10}}</span>元
              </div>
              <div class="yellow_btn" @click="gotoPay">
                去购买
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="showLoading" ></Loading>
    <Content v-if="showContent" :needPoint="money" @close="showContent=false" :course="course" @resetList="resetList" :ifcharge="ifcharge" :url="url"></Content>
  </div>
</template>
<script>
import axios from 'axios'
import Loading from '../components/components/Loading.vue';
import Content from '../components/components/Content.vue'
import emo from '../../assets/js/frame'
export default {
  components: { Loading,Content },
  name: "videoClass",
  data(){
    return{
        tableList:[],//课程列表
        showLoading:false,
        courseID:[],
        money:0,
        showContent:false,
        course:[],
        ifcharge:true,//是否是通过兑换登录
        url:'',
    }
  },
  methods:{
    listen(url,index,indexs){//点击播放，后两个参数记录登陆前点击的位置
      if(!this.$store.state.token){
        this.ifcharge=false
        this.showContent=true
        this.$store.commit('setVideo',[index,indexs])
        this.url='video'
        return
      }
      if(!url){
        this.wh8alert('请先购买或兑换本课程，之后即可听课或下载 PPT。')
        return
      }
      var mask_bg = document.createElement("div");
            mask_bg.id = "mask_bg";
            mask_bg.style.position = "fixed";
            mask_bg.style.top = "0px";
            mask_bg.style.left = "0px";
            mask_bg.style.width = "100%";
            mask_bg.style.height = "100%";
            mask_bg.style.backgroundColor = "rgba(0,0,0,0.6)";
            // mask_bg.style.opacity = 0.6;
            mask_bg.style.zIndex = 1111111;
            document.body.appendChild(mask_bg);
            var alertcont =document.createElement('div');
            alertcont.classList.add('frames')
            alertcont.style.width='1000px'
            alertcont.style.height='600px'
            alertcont.style.position='relative'
            alertcont.style.background='black'
            alertcont.style.left='20%'
            alertcont.style.top='20%'
            alertcont.style.zIndex = 111111111;
            mask_bg.appendChild(alertcont);
            var alertcont2=document.createElement('div');
            alertcont2.style.position='relative'
            alertcont2.style.width='100%'
            alertcont2.style.height='100%'
            alertcont.appendChild(alertcont2);
            var bao=document.createElement('video');
            bao.src=url
            bao.style.width='100%'
            bao.style.height='100%'
            bao.style.margin='0'
            bao.style.border='none'
            bao.style.objectFit='contain'
            bao.controls=true
            alertcont2.appendChild(bao);
            var chabox =document.createElement('img');
            var img=require('../../assets/images/b01.png');
            var img1=require('../../assets/images/c01.png');
            var img2=require('../../assets/images/c02.png');
            chabox.src=img
            chabox.style.position='absolute'
            chabox.style.right='2px'
            chabox.style.top='0'
            chabox.style.width='15px'
            chabox.style.height='15px'
            chabox.style.cursor='pointer'
            chabox.style.userSelect='none'
            var smallbox =document.createElement('img');
            smallbox.src=img1
            smallbox.style.color='white'
            smallbox.style.position='absolute'
            smallbox.style.right='25px'
            smallbox.style.top='0'
            smallbox.style.width='15px'
            smallbox.style.height='15px'
            smallbox.style.cursor='pointer'
            smallbox.style.userSelect='none'
            smallbox.onclick=function(){
                var mask_bgc = document.getElementById("mask_bg").children[0];
                if(mask_bgc.style.width=='100%'){
                mask_bgc.style.width='1000px'
                mask_bgc.style.height='600px'
                mask_bgc.style.left="20%"
                mask_bgc.style.top="20%"
                smallbox.src=img1
                
                }
                else{
                mask_bgc.style.width='100%'
                mask_bgc.style.height='100%'
                mask_bgc.style.left="0%"
                mask_bgc.style.top="0%"
                smallbox.src=img2
                }
            }
            emo.Frames()
            emo.La();
            chabox.onclick=function(){
                var mask_bg = document.getElementById("mask_bg");
            if (mask_bg != null)
                mask_bg.parentNode.removeChild(mask_bg);
            }
            alertcont2.appendChild(chabox);
            alertcont2.appendChild(smallbox);
    },
    downloadPPt(ppt,index){
      if(!this.$store.state.token){
        this.ifcharge=false
        this.showContent=true
        this.$store.commit('setPpt',index)
        this.url='ppt'
        return
      }
      if(!ppt){
        this.wh8alert('请先购买或兑换本课程，之后即可听课或下载 PPT。')
        return
      }
      else{
        window.open(ppt)
      }
    },
    starcomp(i){
      let star = ''
      while(i>0){
        star= star+'★'
        i--
      }
      return  star
    },
    changestaus(index,item){
      if(!item.active&&!!item.ppt){
        return
      }
      this.$set(this.tableList[index],'active',!this.tableList[index].active)
      this.changemoney()
    },
    changemoney(){
      this.money = 0
      this.tableList.forEach((el)=>{
        if(el.active){
          this.money = this.money + el.integral
        }
      })
    },
    gotoLogin(){
      this.ifcharge=true
      this.showContent=true
      this.course=[]
      this.tableList.forEach((el,idx)=>{
        if(el.active){
          el.Courses.forEach((els,idxs)=>{
            this.course.push(els.product_subid)
          })
        }
      })
    },
    resetList(ifgoumai,url){
    this.showLoading = true
    console.log(this.$store.state)
    axios({
    headers: {
        'Authorization':this.$store.state.token
    },
    method: 'post',
    url: 'https://wt9.wenhua.com.cn/api/AddApi/GetTrainingCourseList',
    data:{
      whid:this.$store.state.whid
    },
    }).then((res)=>{
      if(res.status==200){
        this.showLoading = false
        let ifhas = false,ifall=true
        var newdata=JSON.parse(JSON.stringify(res.data.data))
        newdata.forEach((el,idx)=>{
          el.active=this.tableList[idx].active
          if(!el.ppt){
              ifall=false
          }
          if(!!el.active&&!!el.ppt){
            ifhas = true
          }
        })
        this.tableList=JSON.parse(JSON.stringify(newdata))
        if(ifhas){
          let cr=[]
          this.tableList.forEach((el,idx)=>{
            if(!!el.active&&!!el.ppt){
              el.Courses.forEach((els)=>{
                cr.push(els.productname)
              })
              this.$set(this.tableList[idx],'active',false)
            }
          })
          if(url){
            if(url=='video'){
              this.listen(this.tableList[this.$store.state.video[0]].Courses[this.$store.state.video[1]].url)
            }
            if(url=='ppt'){
              this.downloadPPt(this.tableList[this.$store.state.ppt].ppt)
            }
          }
          if(!ifgoumai){
            console.log(cr)
            this.showContent=false
            ifall?this.wh8alert('所有课程均已完成兑换，您可直接听课啦！'):this.money===0?this.wh8alert('请勾选需要兑换的课程'):this.wh8alert('以下课程已完成兑换，无法重复进行兑换操作。请重新选择。 \n'+cr.join('\n'))
          }
        }
        else{
          if(ifall){
            this.wh8alert('所有课程均已完成兑换，您可直接听课啦！')
            this.showContent=false
          }
          else if(this.money===0){
            this.wh8alert('请勾选需要兑换的课程')
            this.showContent=false
          }
        }
        this.changemoney()
      }
    })
    },
    gotoPay(){
      let list=[]
      this.tableList.forEach((el,idx)=>{
        if(el.active){
          el.Courses.forEach((els,idxs)=>{
            list.push(els.product_subid)
          })
        }
      })
      window.open('https://pay.wenhua.com.cn/#/detail/136?courseIds='+btoa(list.join(',')))
    },
  },

  created(){
    let course =[] 
    if(!!this.$route.query.courseIds)
    {
      course=atob(this.$route.query.courseIds.split(','))
    }
    this.showLoading=true
    axios({
    headers: {
        'Authorization':''
    },
    method: 'post',
    url: 'https://wt9.wenhua.com.cn/api/AddApi/GetTrainingCourseList'
    }).then((res)=>{
      console.log(res)
      this.showLoading=false
      if(res.status==200){
        console.log(res.data.data)
        this.$store.commit('setCourselist',res.data.data)
        this.tableList=JSON.parse(JSON.stringify(res.data.data))
        if(course.length>0){
          this.tableList.forEach((el,idx)=>{
            el.Courses.forEach((els,idxs)=>{
              if(course.includes(String(els.product_subid))){
                this.$set(this.tableList[idx],'active',true)
              }
            })
          })
        }
        else{
          this.tableList.forEach((el,idx)=>{
            this.$set(this.tableList[idx],'active',true)
          })
        }
        this.changemoney()
      }
      else{
        this.wh8alert(res.data.message)
      }
      
    }).catch((err)=>[
      console.log(err)
    ])
  }
};
</script>
<style  scoped>
.videoClass {
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=39) no-repeat top;
  background-size: 100% auto;
  min-width: 1400px;
  width: 100%;
  min-height: 1212px;
  height: 100%;
  padding-top: 110px;
}
.videoClasshtml {
  width: 1000px;
  margin: 0 auto;
  background: #f5f1ee;
  /* min-height: 900px; */
}
.videoClass .content {
  min-height: 537px;
  background: url("../../assets/images/jsbg.jpg") no-repeat top;
  padding: 0 50px 40px 50px;
}
.title {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 40px;
  color: #fff;
}
.kechen .module_tit span {
  display: block;
  background: url("../../assets/images/bq1.png") no-repeat;
  background-size: 100% 30px;
  width: 80px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
}
.jieshao .module_tit span {
  display: block;
  background: url("../../assets/images/bq1.png") no-repeat;
  width: 63px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
}
.zhu span {
  display: block;
  background: #405189;
  border-radius: 0 15px 15px 0;
  width: 63px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
}
.p_text {
  text-indent: 2em;
  font-size: 15px;
  color: #555;
  line-height: 28px;
  letter-spacing: 1px;
}
.pic {
  text-align: center;
  padding: 20px 0;
}

.buy {
  text-align: center;
  color: #fff;
  font-weight: 700;
  line-height: 40px;
  border: none;
  border-radius: 5px;
  letter-spacing: 1px;
  background: url("../../assets/images/buy.png") no-repeat center;
  /* display: inline-block; */
  width: 150px;
  height: 40px;
  font-size: 18px;
  float: right;
}
.buy a{
  color: #fff;
  text-decoration: none;
}
.maiyuy {
  /* background: url(../../assets/images/maiyuy2.png) no-repeat; */
  width: 100%;
  /* height: 250px; */
  /* background-position-x: 100px;
  background-position-y: 10px; */
  /* padding-top: 50px; */
  /* padding-bottom: 20px; */
}
.videoContent{
  margin-left: 530px;
  /* margin-top: 100px; */
}
.videoContent p {
  font-size: 16px;
  font-weight: 700;
  color: #666;
  line-height: 32px;
  letter-spacing: 1px;
}
.videoContent ul li {
       font-size: 12px;
    line-height: 18px;
    color: #474c52;
    list-style-type: none;
    list-style-image: none;
    /* background-image: url(../images/listyle.jpg); */
    background-repeat: no-repeat;
    background-position: left 6px;
    /* padding-left: 10px; */
    padding-bottom: 10px;
 }
 .videoContent ul li::before{
   content: " ";
   width: 7px;
   height: 7px;
   background: #b68e6a;
   display: inline-block;
   vertical-align: middle;
   margin-right: 3px;
 }
 .kecheng_table{
  font-size: 14px;
  background: white;
  border: 1px solid #cdcdcd;
  margin-top: 25px;
 }
 .yellow_btn{
   width: 60px;
   height: 25px;
   color: white;
   background: #f1ae45;
   text-align: center;
   line-height: 25px;
   cursor: pointer;
   border-radius: 3px;
 }
 td {
  height: auto;
  border: none;
  line-height: 14px;
  vertical-align: middle;
  font-size: 14px;
  padding-left: 0px;
  letter-spacing: 0.5px;
}
 .table_bottom{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  font-size: 14px;
  align-items: center;
  padding: 12px 15px;
  color: #818181;
 }
 .kecheng_table table thead th{
  color: white;
  background: #3e6493;
  text-align: center;
  padding: 9px 0;
 }
 .kecheng_table table tbody{
  border-bottom: 1px solid #e5e5e5;
 }
.kecheng_table table tbody td{
  color: #3e6493;
  text-align: center;
  padding: 9px 0;
 }
 .kecheng_table table tbody tr{
  background: white;
 }
 .kecheng_table table tbody tr:nth-of-type(2n){
  background: #fafafa;
 }
 .hreactive{
  color: #0267fd !important;
  cursor: pointer;
  user-select: none;
 }
</style>